<template>
    <div>
        <form>
            <stepper-step
                :number="0"
                :checkBeforeGoToNext="checkFormFields"
                :previous-disabled="disableFormFieldBackButton"
            >
                <client-create-form-fields
                    :can-create-client-admin="canCreateClientAdmin"
                    :is-admin="isAdmin"
                    v-model="clientFormFields"
                    :formerrors="formerrors"
                    :tenant-ident="tenantIdent"
                ></client-create-form-fields>
            </stepper-step>
            <stepper-step
                :number="1"
                :checkBeforeGoToNext="checkLicenseFormFields"
                :previous-disabled="disableFormFieldBackButton"
            >
                <client-license-selection v-model="clientLicenseFields" :formerrors="formerrors">
                </client-license-selection>
            </stepper-step>

            <stepper-step
                :number="2"
                :checkBeforeGoToNext="checkAssignmentsFormFields"
            >
                <client-create-course-assignment
                    v-model="clientCourseFields"
                    :courses="courses"
                    :formerrors="formerrors"
                >
                </client-create-course-assignment>
            </stepper-step>

            <stepper-step
                :number="3"
                is-last-step
            >
            <client-create-summary
                :isLastStep="true"
                :clientFormFields="clientFormFields"
                :clientLicenseFields="clientLicenseFields"
                :clientCourseFields="clientCourseFields"
                :specificUserFields="specificUserFields"
            >
            </client-create-summary>
            </stepper-step>
        </form>
    </div>
</template>

<script>
import ClientCourseAssignment from './ClientCourseAssignment.vue';
import ClientLicenseSelection from './ClientLicenseSelection.vue';
// import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    components: { ClientLicenseSelection, ClientCourseAssignment },
    props: {
        parentId: Number,
        isAdmin: Boolean,
        canCreateClientAdmin: Boolean,
        courses: Array,
        tenantIdent: String,
    },

    data() {
        return {
            parentClient: this.parentClient,
            clientFormFields: {},
            clientLicenseFields: {},
            clientCourseFields: {},
            formerrors: {},
            disableFormFieldBackButton: false,
            disableAssignmentBackButton: false,
            fields: { parent_id: this.parentId || null },
        };
    },
    methods: {
        checkFormFields() {
            var postObject = this.getClientFormFieldsPostObject();

            return axios
                .post(this.route('tenantapi.clients.data.validate'), postObject)
                .then((response) => {
                    this.disableFormFieldBackButton = false;
                    this.formerrors = {};

                    return true;
                })
                .catch((error) => {
                    this.formerrors = error.response.data.errors;
                    this.disableFormFieldBackButton = true;

                    this.flash({message: this.trans('validation.form.fill_required_fields'), level: 'warning'});

                    return false;
                });
        },

        checkLicenseFormFields() {
            var postObject = this.getClientFormFieldsPostObject();

            return axios
                .post(this.route('tenantapi.clients.license.validate'), postObject)
                .then((response) => {
                    this.disableFormFieldBackButton = false;
                    this.formerrors = {};

                    return true;
                })
                .catch((error) => {
                    this.formerrors = error.response.data.errors;
                    this.disableFormFieldBackButton = true;

                    this.flash({message: this.trans('validation.form.fill_required_fields'), level: 'warning'});

                    return false;
                });
        },

        checkAssignmentsFormFields() {
            var postObject = this.getClientFormFieldsPostObject();

            return axios
                .post(this.route('tenantapi.clients.course.validate'), postObject)
                .then((response) => {
                    this.disableFormFieldBackButton = false;
                    this.formerrors = {};

                    return true;
                })
                .catch((error) => {
                    this.formerrors = error.response.data.errors;
                    this.disableFormFieldBackButton = true;

                    this.flash({message: this.trans('validation.form.fill_required_fields'), level: 'warning'});

                    return false;
                });
        },

        formatClientCoursesForBackend() {
            var selected = [];
            if (this.clientCourseFields && this.clientCourseFields.length > 0) {
                this.clientCourseFields.forEach((c) => {
                    selected.push({
                        course_id: c['course'] ? c['course'].value : null,
                        course_variation_id: c['coursevariation'] ? c['coursevariation'].value : null,
                    });
                });
            }

            return selected;
        },

        formatClientSpecificUserFieldsForBackend() {
            var specificUserFields = [];
            if(this.clientFormFields.specificUserFields && this.clientFormFields.specificUserFields.length > 0) {
                this.clientFormFields.specificUserFields.forEach((field) => {
                    console.log(field.required);
                    specificUserFields.push({
                        name: field.name,
                        required: field.required,
                        key: field.key
                    });
                });
            }
            return specificUserFields;
        },

        getClientFormFieldsPostObject() {
            var selectedCourses = this.formatClientCoursesForBackend();
            var specificUserFields = this.formatClientSpecificUserFieldsForBackend();
            var postObject = {
                parent_id: this.parentId,
                name: this.clientFormFields.name,
                street: this.clientFormFields.street,
                zip: this.clientFormFields.zip,
                city: this.clientFormFields.city,
                country: this.clientFormFields.country,
                differing_billing_address:
                    this.clientFormFields.differingBillingAddress,
                user_deletion_interval:
                    this.clientFormFields.userDeletionInterval,
                overdue_delay: this.clientFormFields.overdueDelay,
                static_next_assignment:
                    this.clientFormFields.staticNextAssignment,
                access_subclient: this.clientFormFields.accessSubclient,
                specific_user_fields: specificUserFields,
                create_client_admin: this.clientFormFields.createClientAdmin,
                api_token_exists: this.clientFormFields.apiTokenExists,

                license_plan: this.clientLicenseFields.licensePlan,
            };

            if (this.clientLicenseFields.licensePlan == "license_plan_alpha") {
                if (this.clientLicenseFields.licenseAmount > 0) {
                    postObject = {
                        repeat: this.clientLicenseFields.repeat,
                        repeat_period: this.clientLicenseFields.repeatPeriod,
                        ...postObject,
                    };
                }
                postObject = {
                    can_buy_licenses: this.clientLicenseFields.canBuyLicenses,
                    expiration_period:
                        this.clientLicenseFields.expirationPeriod,
                    license_amount: this.clientLicenseFields.licenseAmount,
                    ...postObject,
                };
            }
            if (this.clientLicenseFields.licensePlan == "license_plan_beta") {
                postObject = {
                    accounting_period:
                        this.clientLicenseFields.accountingPeriod,
                    accounting_email: this.clientLicenseFields.accountingEmail,
                    ...postObject,
                };
            }

            if (this.clientFormFields.createClientAdmin) {
                postObject = {
                    firstname: this.clientFormFields.firstname,
                    lastname: this.clientFormFields.lastname,
                    email: this.clientFormFields.email,
                    ...postObject,
                };
            }

            if (selectedCourses.length > 0) {
                postObject = {
                    selectedCourses,
                    ...postObject,
                };
            }

            if (this.clientFormFields.differingBillingAddress) {
                postObject = {
                    billing_street: this.clientFormFields.billingStreet,
                    billing_zip: this.clientFormFields.billingZip,
                    billing_city: this.clientFormFields.billingCity,
                    billing_country: this.clientFormFields.billingCountry,
                    ...postObject,
                };
            }

            if (this.clientFormFields.apiToken) {
                postObject = {
                    api_token: this.clientFormFields.apiToken,
                    ...postObject,
                };
            }

            return postObject;
        },

        submitForm() {
            var postObject = this.getClientFormFieldsPostObject();
            axios
                .post(this.route('tenantapi.clients.store'), postObject)
                .then(this.handleResponse)
                .catch(({ response }) => {
                    this.errors = response.data.errors;
                });
        },

        handleResponse(response) {
            if (response.status == 200) {
                this.flash({message: this.trans('clients.flash.client_created'), level: 'success'});

                if (this.parentId) {
                    location.href = this.route('tenant.clients.show', {client: this.parentId});
                } else {
                    location.href = this.route('tenant.clients.index');
                }
            }
        },
    },

    computed: {
        nextEnabledClientSelection() {
            return true;
        },

        specificUserFields() {
            return this.formatClientSpecificUserFieldsForBackend();
        }
    },

    mounted() {
        EventBus.$on('submitForm', () => {
            this.submitForm();
        });
    },
};
</script>
